import React from 'react';
import Select from '../../../components/ui/Select';

const AudienceDemographicsSelect = ({ value, onChange, error }) => {
  const demographicOptions = [
    { value: '13-17', label: '13-17 years (Gen Z)' },
    { value: '18-24', label: '18-24 years (Gen Z/Millennial)' },
    { value: '25-34', label: '25-34 years (Millennial)' },
    { value: '35-44', label: '35-44 years (Millennial/Gen X)' },
    { value: '45-54', label: '45-54 years (Gen X)' },
    { value: '55+', label: '55+ years (Boomer+)' }
  ];

  return (
    <Select
      label="Primary Audience Age Range"
      description="Select the age group that makes up most of your audience"
      options={demographicOptions}
      value={value}
      onChange={onChange}
      error={error}
      placeholder="Choose audience age range"
    />
  );
};

export default AudienceDemographicsSelect;